import React, {memo} from 'react';
import './PageHeader.less';
import {PageHeaderTitle} from "elements/page-header-title/PageHeaderTitle";
import {PageHeaderDescription} from "elements/page-header-description/PageHeaderDescription";

export const PageHeader = memo(({title, description}) => {
	return <div className="page-header">
		<div className="page-header__title">
			<PageHeaderTitle text={title}/>
		</div>
		<div className="page-header__description">
			<PageHeaderDescription text={description}/>
		</div>
	</div>
})
